import Button from '@material-ui/core/Button';
import {
    disableMenuOption,
    enableMenuOption,
    restartMenuOption,
    updateMenuOption,
    useHandleAction,
} from './ActionButtonHelper';

const buttons = [updateMenuOption, enableMenuOption, disableMenuOption, restartMenuOption];

export default function AgentListActionButtons({
    actionsDisabled,
    tableSelection,
    tableState,
    refresherFunc,
    dataSource,
}) {
    const handleAction = useHandleAction(dataSource);

    const handleActionClick = (menuOption) => {
        return handleAction(menuOption, tableState, tableSelection, refresherFunc);
    };

    return (
        <>
            {buttons.map((option) => (
                <Button key={option.key} disabled={actionsDisabled} onClick={() => handleActionClick(option)}>
                    {option.text}
                </Button>
            ))}
        </>
    );
}
